<template>
  <el-container>
    <el-main v-loading="loading" style="padding:0 20px 0 20px;height:640px;width:100%;overflow:auto;">
      <div v-if="cow_select === ''">
        <el-row :gutter="20" style="justify-content:right;padding-top: 1em;">
          <el-col :span="11">
            <div>
              <el-pagination background hide-on-single-page layout="prev, pager, next" :current-page="sortCowsIndex + 1"
                :page-size="cowsPerPageSize" :total="sortCowsTotalCount" @current-change="pageChange" />
            </div>
          </el-col>
          <el-col :span="3" style="min-width:140px;">
            <div>
              <el-button color="#EEEEEC" class="operation-btn" @click="openDialog()">
                <el-icon :style="{ color: icon_color, paddingRight: '1em' }"><icon-adjustment /></el-icon>絞り込み
              </el-button>
            </div>
          </el-col>
          <el-col :span="1">
            <el-switch v-model="isSearchNumber" inline-prompt size="large"
              style="--el-switch-on-color: #ffcc00; --el-switch-off-color: #ffcc00;margin-top:0.4em;" active-text="耳標"
              inactive-text="名前">
            </el-switch>
          </el-col>
          <el-col :span="6">
            <div style="display:flex;position:relative;width:100%;">
              <el-dropdown ref="dropdown1" @command="handleCommand" max-height="300"
                style="height:50px;min-width:164px;width:100%;position:absolute;left:0px;top:0px;">
                <div style="display:flex;position:relative;width:100%;">
                  <el-input ref="elinp" id="elinp" v-model="search_text" v-on:keydown.enter="filterUpdate()"
                    :prefix-icon="IconMagnifyingGlass" :suffix-icon="IconClear" :placeholder="search_text_placeholder"
                    :maxlength="search_text_maxlength" style="height:50px;min-width:164px;z-index: 1999;"
                    @input="validate">
                  </el-input>
                  <div style="width:0px;position:relative;">
                    <el-button type="primary" @click="search_text = ''; filterUpdate();"
                      style="position:absolute;left:-33px;top:0px;height:50px;opacity:0;z-index:1999" />
                  </div>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item v-for="suggestionData in this.suggestionsData" :key="suggestionData.value"
                      :label="suggestionData.label" :value="suggestionData.label" :command="suggestionData.label">{{
                        suggestionData.label
                      }}</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
        <el-row style="justify-content: right; padding-top: 5px; padding-bottom: 5px;">
          <el-button v-if="filter_emptywomb" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(0)">空胎<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_inseminated" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(1)">人工授精済<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_transfered" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(3)">受精卵移植済<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_pregnant" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(2)">妊娠中<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_adultcattle" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(10)">成牛<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_calf" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(11)">子牛<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_shipping" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(12)">出荷<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_deathdisuse" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(13)">死亡・廃用<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_status_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(14)">状態未選択<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_cow" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(20)">メス<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_bull" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(21)">オス<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_sex_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(22)">性別未選択<el-icon>
              <CircleCloseFilled />
            </el-icon></el-button>
          <el-button v-if="filter_wagyu" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(30)">黒毛和牛<el-icon>
              <IconClear />
            </el-icon></el-button>
          <el-button v-if="filter_holstein" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(31)">ホルスタイン<el-icon>
              <IconClear />
            </el-icon></el-button>
          <el-button v-if="filter_f1" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(32)">F1<el-icon>
              <IconClear />
            </el-icon></el-button>
          <el-button v-if="filter_redcow" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(33)">赤牛<el-icon>
              <IconClear />
            </el-icon></el-button>
          <el-button v-if="filter_breed_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(34)">種類未選択<el-icon>
              <IconClear />
            </el-icon></el-button>
          <el-button v-if="filter_in_barn" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
            @click="filterDisable(40)">牛房内の牛<el-icon>
              <IconClear />
            </el-icon></el-button>
        </el-row>
        <div v-if="tableData.length != 0">
          <el-table :data="tableData" :default-sort="{ prop: 'lastestruson', order: 'descending' }" height="540px" stripe
            @row-click="selectedCalfCow" style="min-width:715px;">
            <el-table-column label="" :width="headerWidth" />
            <el-table-column style="background: #EEEEEC;" prop="name">
              <template #header>
                <label>名前</label>
                <el-button class="link-icon" link :icon="sortIcons[4]" @click="sortSetting(4)"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="no" label="個体識別番号">
            </el-table-column>
            <el-table-column prop="breed" label="種類">
            </el-table-column>
            <el-table-column prop="fertilizationdate">
              <template #header>
                <label>人工授精日</label>
                <el-button link :icon="sortIcons[0]" @click="sortSetting(0)"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="transferdate">
              <template #header>
                <label>受精卵移植日</label>
                <el-button link :icon="sortIcons[1]" @click="sortSetting(1)"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="birthdate">
              <template #header>
                <label>出産予定日</label>
                <el-button link :icon="sortIcons[2]" @click="sortSetting(2)"></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="lastbirthon">
              <template #header>
                <label>最終出産日</label>
                <el-button link :icon="sortIcons[3]" @click="sortSetting(3)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="!loading & (orgTableData.length == 0 || tableData.length == 0)">
          <el-row class="width100">
            <el-row class="width100" style="justify-content:center;margin-top:5%;">
              <p class="font_18 font_bold">該当する牛がいません</p>
            </el-row>
            <el-row class="width100" style="justify-content:center;">
              <img src="@/assets/ImgIllustAlertEmpty.png" />
            </el-row>
          </el-row>
        </div>
        <el-dialog v-model="cowSelectFilterDialog" title="" width="544px">
          <el-row class="bottom-padding">
            <el-col :span="12">
              <span class="filter-left">牛絞り込み</span>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row> <el-row></el-row>
          <el-row>
            <el-col :span="12">
              <span class="filter-left">妊娠状況</span>
            </el-col>
            <el-col :span="12">
              <span>状態</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_emptywomb" label="空胎" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_adultcattle" label="成牛" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_inseminated" label="人工授精済" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_calf" label="子牛" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_transfered" label="受精卵移植済" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_shipping" label="出荷" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_pregnant" label="妊娠中" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_deathdisuse" label="死亡・廃用" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"></el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_status_noset" label="未選択" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <span class="filter-left">性別</span>
            </el-col>
            <el-col :span="12">種類</el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_cow" label="メス" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_wagyu" label="黒毛和牛" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_bull" label="オス" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_holstein" label="ホルスタイン" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-checkbox v-model="dialog_sex_noset" label="未選択" size="large" class="filter-left" />
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_f1" label="F1" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"></el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_redcow" label="赤牛" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"></el-col>
            <el-col :span="12">
              <el-checkbox v-model="dialog_breed_noset" label="未選択" size="large" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <span class="filter-left">その他</span>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-checkbox v-model="dialog_in_barn" label="牛房登録中の牛は必ず表示" size="large" class="filter-left" />
            </el-col>
          </el-row>
          <template #footer>
            <el-row style="justify-content: center;">
              <el-button class="left-button" round @click="filterClear()">クリア</el-button>
              <el-button class="right-button" round @click="setFilter()">絞り込み</el-button>
            </el-row>
          </template>
        </el-dialog>
      </div>
    </el-main>
    <el-footer :style="{ overflowx: 'auto', background: 'white', paddingTop: '10px' }">
      <div style="width:100%;overflow:auto;">
        <el-row style="justify-content:center;">
          <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
            @click="selectCancel()">戻る</el-button>
        </el-row>
      </div>
    </el-footer>
  </el-container>
</template>
<script>
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from '../views/js/cognito';
import ConstParam from '../views/js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'
import AWSAPI from '../views/js/aws-api';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

// 定数定義
const colorYellow = "#FFB600";
const colorNormal = "#383838";
const constFilterParam = {
  save: true,
  sortParam: [0, 0, 0, 1, 0], // 人工授精日、受精卵移植日、出産予定日、最終出産日、名前
  searchMode: true,
  searchText: "",
  filter_emptywomb: false,
  filter_inseminated: false,
  filter_pregnant: false,
  filter_transfered: false,
  filter_adultcattle: false,
  filter_calf: false,
  filter_shipping: false,
  filter_deathdisuse: false,
  filter_status_noset: false,
  filter_cow: false,
  filter_bull: false,
  filter_sex_noset: false,
  filter_wagyu: false,
  filter_holstein: false,
  filter_f1: false,
  filter_redcow: false,
  filter_breed_noset: false,
  filter_in_barn: false
}

export default {
  props: ['headerWidth', 'farmerId'],
  emits: ['dialogClose', 'selectedCalfCow', 'cowsData'],
  data() {
    return {
      filterParam: {},
      cowNumberNames: {},
      suggestionsData: [],
      suggestionsDatas: { cows_name: [], cows_number: [] },
      cow_kinds: ConstParam.cow_kinds,
      cowsData: [],
      cowsPerPageSize: ConstParam.cows_per_page,
      cowSortKey: ConstParam.cow_sort_key,
      sortCowsIndex: 0,
      sortCowsAscending: true,
      sortOrder: 0,
      sortCowsIndexCount: 0,
      sortCowsTotalCount: 0,
      sortCowsListKey: {},
      sortCowsListKeyArray: [],
      sortCowsListCount: [],
      sortCowsListData: [],
      sortCowsData: [],
      updateSortCowsData: [],
      //
      sortLevel: [0, 0, 0, 1, 0],
      sortIndex: -1,
      sortIconNames: ["IconArrowUpDown1", "IconArrowUpDown2", "IconArrowUpDown3"],
      sortIcons: ["IconArrowUpDown1", "IconArrowUpDown1", "IconArrowUpDown1", "IconArrowUpDown2"],
      sortNames: ["fertilizationdate", "transferdate", "birthdate", "lastbirthon"],
      IconArrowUpDown1: shallowRef(icons.IconArrowUpDown1),
      IconArrowUpDown2: shallowRef(icons.IconArrowUpDown2),
      IconArrowUpDown3: shallowRef(icons.IconArrowUpDown3),
      IconAdjustment: shallowRef(icons.IconAdjustment),
      IconMagnifyingGlass: shallowRef(icons.IconMagnifyingGlass),
      IconClear: shallowRef(icons.IconClear),
      cowSelectFilterDialog: false,
      // フィルター変数
      icon_color: colorNormal,
      filter_emptywomb: false,
      filter_inseminated: false,
      filter_pregnant: false,
      filter_transfered: false,
      filter_adultcattle: false,
      filter_calf: false,
      filter_shipping: false,
      filter_deathdisuse: false,
      filter_status_noset: false,
      filter_cow: false,
      filter_bull: false,
      filter_sex_noset: false,
      filter_wagyu: false,
      filter_holstein: false,
      filter_f1: false,
      filter_redcow: false,
      filter_breed_noset: false,
      filter_in_barn: false,
      // フィルターワーク
      dialog_emptywomb: false,
      dialog_inseminated: false,
      dialog_pregnant: false,
      dialog_transfered: false,
      dialog_adultcattle: false,
      dialog_calf: false,
      dialog_shipping: false,
      dialog_deathdisuse: false,
      dialog_status_noset: false,
      dialog_cow: false,
      dialog_bull: false,
      dialog_sex_noset: false,
      dialog_wagyu: false,
      dialog_holstein: false,
      dialog_f1: false,
      dialog_redcow: false,
      dialog_breed_noset: false,
      dialog_in_barn: false,
      // その他
      maxLength: ConstParam.maxLength,
      loading: false,
      cow_edit: false,
      cow_select: "",
      orgTableData: [],
      tableData: [],
      search_text: "",
      search_text_maxlength: ConstParam.number_maxLength,
      search_text_placeholder: ConstParam.search_text_placeholder_number,
      isSearchNumber: true,
      // 個体情報
      cow_id: "",
      cow_name: "",
      cow_number: "",
      cow_breed: "",
    }
  },
  updated() {
    this.restore_param()
    this.getCowsDataFirst()
  },
  mounted() {
    this.restore_param()
    this.getCowsDataFirst()
  },
  methods: {
    restore_param() {
      // パラメータ復元
      this.filterParam = this.$store.state.calfCowFilterParam
      if (!this.filterParam || !this.filterParam.save) {
        this.$store.commit('setCalfCowFilterParam', constFilterParam)
        this.filterParam = this.$store.state.calfCowFilterParam
      }
      this.setFilterParam()
      this.setSortParam()
    },
    setSortParam() {
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (this.sortLevel[idx] > 0) {
          this.sortIndex = idx
          if (this.sortLevel[idx] == 1) {
            // 降順ソート
            this.sortCowsAscending = true
          } else {
            // 昇順ソート
            this.sortCowsAscending = false
          }
          // ソート項目設定
          this.sortOrder = this.cowSortKey[idx]
        }
        this.sortIcons[idx] = this.sortIconNames[this.sortLevel[idx]]
      }
    },
    setFilterParam() {
      // ソート条件
      this.sortLevel = structuredClone(this.filterParam.sortParam)
      // 検索条件
      this.isSearchNumber = this.filterParam.searchMode
      this.search_text = this.filterParam.searchText
      // フィルター設定
      this.filter_emptywomb = this.filterParam.filter_emptywomb
      this.filter_inseminated = this.filterParam.filter_inseminated
      this.filter_pregnant = this.filterParam.filter_pregnant
      this.filter_transfered = this.filterParam.filter_transfered
      this.filter_adultcattle = this.filterParam.filter_adultcattle
      this.filter_calf = this.filterParam.filter_calf
      this.filter_shipping = this.filterParam.filter_shipping
      this.filter_deathdisuse = this.filterParam.filter_deathdisuse
      this.filter_status_noset = this.filterParam.filter_status_noset
      this.filter_cow = this.filterParam.filter_cow
      this.filter_bull = this.filterParam.filter_bull
      this.filter_sex_noset = this.filterParam.filter_sex_noset
      this.filter_wagyu = this.filterParam.filter_wagyu
      this.filter_holstein = this.filterParam.filter_holstein
      this.filter_f1 = this.filterParam.filter_f1
      this.filter_redcow = this.filterParam.filter_redcow
      this.filter_breed_noset = this.filterParam.filter_breed_noset
      this.filter_in_barn = this.filterParam.filter_in_barn
    },
    saveFilterParam() {
      let tempParam = {
        save: true,
        sortParam: this.sortLevel,
        searchMode: this.isSearchNumber,
        searchText: this.search_text,
        filter_emptywomb: this.filter_emptywomb,
        filter_inseminated: this.filter_inseminated,
        filter_pregnant: this.filter_pregnant,
        filter_transfered: this.filter_transfered,
        filter_adultcattle: this.filter_adultcattle,
        filter_calf: this.filter_calf,
        filter_shipping: this.filter_shipping,
        filter_deathdisuse: this.filter_deathdisuse,
        filter_status_noset: this.filter_status_noset,
        filter_cow: this.filter_cow,
        filter_bull: this.filter_bull,
        filter_sex_noset: this.filter_sex_noset,
        filter_wagyu: this.filter_wagyu,
        filter_holstein: this.filter_holstein,
        filter_f1: this.filter_f1,
        filter_redcow: this.filter_redcow,
        filter_breed_noset: this.filter_breed_noset,
        filter_in_barn: this.filter_in_barn
      }
      this.$store.commit('setCalfCowFilterParam', tempParam)
    },
    handleCommand(command) {
      this.search_text = command
      this.filterUpdate()
    },
    setSuggestionsDatas(farmer) {
      this.suggestionsDatas.cows_name = []
      this.suggestionsDatas.cows_number = []
      // サジェスチョンデータの準備
      if (farmer && 'cow_names' in farmer) {
        this.suggestionsDatas.cows_name = structuredClone(farmer.cow_names)
      }
      if (farmer && 'cow_numbers' in farmer) {
        this.suggestionsDatas.cows_number = structuredClone(farmer.cow_numbers)
      }
      // cowsName.sort((a, b) => a - b)
      // cowsNumber.sort((a, b) => a - b)
      this.setSuggestionsData()
    },
    setSuggestionsData() {
      this.suggestionsData = []
      let tempCowsData = []
      let tempData = []
      if (this.isSearchNumber) {
        tempData = structuredClone(this.suggestionsDatas.cows_number)
      } else {
        tempData = structuredClone(this.suggestionsDatas.cows_name)
      }
      if (this.search_text !== "") {
        tempCowsData = tempData.filter(word => word.indexOf(this.search_text) == 0)
      } else {
        tempCowsData = tempData
      }
      for (let idx = 0; idx < tempCowsData.length; idx++) {
        let tempData = {
          value: tempCowsData[idx],
          label: tempCowsData[idx]
        }
        this.suggestionsData.push(tempData)
      }
    },
    pageChange(val) {
      this.sortCowsIndex = val - 1
      if (val > this.sortCowsIndexCount) {
        // 次ページデータ取得
        this.getCowsDataNext()
      } else {
        // 取得済みページ切り替え
        this.cowsData = structuredClone(this.sortCowsListData[this.sortCowsIndex])
      }
    },
    getSortCowsCount() {
      let cowsCount = 0
      for (let idx = 0; idx < this.sortCowsListData.length; idx++) {
        cowsCount += this.sortCowsListData[idx].length
      }
      return cowsCount
    },
    getCowNumberNames: async function () {
      if (this.farmerId === "") {
        return
      }
      // this.cowNumberNames = {}
      await AWSAPI.getCowNumberNames(
        this.farmerId
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.cowNumberNames = res.data.data[0];
          }
        });
    },
    getCowsDataFirst() {
      this.loading = true;
      this.tableData = []
      this.getCowsData({}, this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
      this.getCowNumberNames()
    },
    getCowsDataNext() {
      if (this.sortCowsListKey != {}) {
        this.loading = true;
        this.tableData = []
        this.getCowsData(this.sortCowsListKey, this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
        this.getCowNumberNames()
      }
    },
    getCowsDataUpdate() {
      if (this.sortCowsListKey != {}) {
        this.loading = true;
        this.tableData = []
        this.getCowsDataIndex(this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
        this.getCowNumberNames()
      }
    },
    getCowsData: async function (
      start_key, cow_sort, cow_sort_forward, cow_in_barn, cow_search_text, is_number
    ) {
      if (this.farmerId === "") {
        return
      }
      // フィルタ適用
      let cow_pregnancy_status = []
      if (this.filter_emptywomb) { cow_pregnancy_status.push(0) }
      if (this.filter_inseminated) { cow_pregnancy_status.push(1) }
      if (this.filter_pregnant) { cow_pregnancy_status.push(2) }
      if (this.filter_transfered) { cow_pregnancy_status.push(3) }
      let cow_status = []
      if (this.filter_adultcattle) { cow_status.push(0) }
      if (this.filter_calf) { cow_status.push(1) }
      if (this.filter_shipping) { cow_status.push(2) }
      if (this.filter_deathdisuse) { cow_status.push(3) }
      let cow_status_not_exists = false
      if (this.filter_status_noset) { cow_status_not_exists = true }
      let cow_sex = []
      if (this.filter_cow) { cow_sex.push(0) }
      if (this.filter_bull) { cow_sex.push(1) }
      let cow_sex_not_exists = false
      if (this.filter_sex_noset) { cow_sex_not_exists = true }
      let cow_breed = []
      if (this.filter_wagyu) { cow_breed.push(0) }
      if (this.filter_holstein) { cow_breed.push(1) }
      if (this.filter_f1) { cow_breed.push(2) }
      if (this.filter_redcow) { cow_breed.push(3) }
      let cow_breed_not_exists = false
      if (this.filter_breed_noset) { cow_breed_not_exists = true }
      cow_in_barn = this.filter_in_barn
      // 検索文字列(設定無効なら空白文字列に設定)
      if (!cow_search_text) { cow_search_text = "" }
      // 初回呼び出しかどうか
      if (Object.keys(start_key).length == 0) {
        // 初回呼び出し
        this.sortCowsIndexCount = 0
        this.sortCowsTotalCount = 0
        this.sortCowsIndex = 0
        this.sortCowsListKey = {}
        this.sortCowsListKeyArray = []
        this.sortCowsListCount = []
        this.sortCowsListData = []
      }
      await AWSAPI.getSortCows(
        this.farmerId,
        start_key,
        cow_sort,
        cow_sort_forward,
        cow_pregnancy_status,
        cow_status,
        cow_status_not_exists,
        cow_sex,
        cow_sex_not_exists,
        cow_breed,
        cow_breed_not_exists,
        cow_in_barn,
        cow_search_text,
        is_number
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.sortCowsData = res['data'];
            this.loading = false
          }
        });
    },
    getCowsDataIndex: async function (
      cow_sort, cow_sort_forward, cow_in_barn, cow_search_text, is_number
    ) {
      if (this.farmerId === "") {
        return
      }
      // フィルタ適用
      let cow_pregnancy_status = []
      if (this.filter_emptywomb) { cow_pregnancy_status.push(0) }
      if (this.filter_inseminated) { cow_pregnancy_status.push(1) }
      if (this.filter_pregnant) { cow_pregnancy_status.push(2) }
      if (this.filter_transfered) { cow_pregnancy_status.push(3) }
      let cow_status = []
      if (this.filter_adultcattle) { cow_status.push(0) }
      if (this.filter_calf) { cow_status.push(1) }
      if (this.filter_shipping) { cow_status.push(2) }
      if (this.filter_deathdisuse) { cow_status.push(3) }
      let cow_status_not_exists = false
      if (this.filter_status_noset) { cow_status_not_exists = true }
      let cow_sex = []
      if (this.filter_cow) { cow_sex.push(0) }
      if (this.filter_bull) { cow_sex.push(1) }
      let cow_sex_not_exists = false
      if (this.filter_sex_noset) { cow_sex_not_exists = true }
      let cow_breed = []
      if (this.filter_wagyu) { cow_breed.push(0) }
      if (this.filter_holstein) { cow_breed.push(1) }
      if (this.filter_f1) { cow_breed.push(2) }
      if (this.filter_redcow) { cow_breed.push(3) }
      let cow_breed_not_exists = false
      if (this.filter_breed_noset) { cow_breed_not_exists = true }
      cow_in_barn = this.filter_in_barn
      // 検索文字列(設定無効なら空白文字列に設定)
      if (!cow_search_text) { cow_search_text = "" }
      // キーの有無
      let start_key = {}
      let tempIndex = this.sortCowsIndex - 1
      if (tempIndex >= 0) {
        if (Object.keys(this.sortCowsListKeyArray[tempIndex]).length != 0) {
          start_key = structuredClone(this.sortCowsListKeyArray[tempIndex])
        }
      }
      await AWSAPI.getSortCows(
        this.farmerId,
        start_key,
        cow_sort,
        cow_sort_forward,
        cow_pregnancy_status,
        cow_status,
        cow_status_not_exists,
        cow_sex,
        cow_sex_not_exists,
        cow_breed,
        cow_breed_not_exists,
        cow_in_barn,
        cow_search_text,
        is_number
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.updateSortCowsData = res['data'];
            this.loading = false
          }
        });
    },
    // getSortCows end
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    // Dialog edit end
    sortSetting(index) {
      this.sortIndex = index;
      this.tableUserData = [];
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (idx == index) {
          this.sortLevel[idx] = (this.sortLevel[idx] + 1) % 3;
          if (this.sortLevel[idx] == 0) {
            this.sortLevel[idx] = 1
          }
        } else {
          this.sortLevel[idx] = 0;
        }
        this.sortIcons[idx] = this.sortIconNames[this.sortLevel[idx]];
      }
      // フィルター再適用
      this.filterUpdate();
    },
    validate() {
      this.search_text = this.search_text.replace(/\D/g, '')
    },
    selectedCalfCow(val) {
      let idx = this.selectCowsDataID(val['id'])
      if (idx != -1) {
        this.$emit("selectedCalfCow", this.cowsData[idx])
      }
    },
    filterDisable(filterNumber) {
      if (filterNumber == 0) { this.filter_emptywomb = false; }
      else if (filterNumber == 1) { this.filter_inseminated = false; }
      else if (filterNumber == 2) { this.filter_pregnant = false; }
      else if (filterNumber == 3) { this.filter_transfered = false; }
      else if (filterNumber == 10) { this.filter_adultcattle = false; }
      else if (filterNumber == 11) { this.filter_calf = false; }
      else if (filterNumber == 12) { this.filter_shipping = false; }
      else if (filterNumber == 13) { this.filter_deathdisuse = false; }
      else if (filterNumber == 14) { this.filter_status_noset = false; }
      else if (filterNumber == 20) { this.filter_cow = false; }
      else if (filterNumber == 21) { this.filter_bull = false; }
      else if (filterNumber == 22) { this.filter_sex_noset = false; }
      else if (filterNumber == 30) { this.filter_wagyu = false; }
      else if (filterNumber == 31) { this.filter_holstein = false; }
      else if (filterNumber == 32) { this.filter_f1 = false; }
      else if (filterNumber == 33) { this.filter_redcow = false; }
      else if (filterNumber == 34) { this.filter_breed_noset = false; }
      else if (filterNumber == 40) { this.filter_in_barn = false; }
      // フィルター再適用
      this.filterUpdate();
    },
    filterClear() {
      this.dialog_emptywomb = false;
      this.dialog_inseminated = false;
      this.dialog_pregnant = false;
      this.dialog_transfered = false;
      this.dialog_adultcattle = false;
      this.dialog_calf = false;
      this.dialog_shipping = false;
      this.dialog_deathdisuse = false;
      this.dialog_status_noset = false;
      this.dialog_cow = false;
      this.dialog_bull = false;
      this.dialog_sex_noset = false;
      this.dialog_breed_noset = false;
      this.dialog_wagyu = false;
      this.dialog_holstein = false;
      this.dialog_f1 = false;
      this.dialog_redcow = false;
      this.dialog_in_barn = false;
      // フィルター再適用
      this.filterUpdate();
    },
    openDialog() {
      // フィルター設定内容の複写
      this.dialog_emptywomb = this.filter_emptywomb;
      this.dialog_inseminated = this.filter_inseminated;
      this.dialog_pregnant = this.filter_pregnant;
      this.dialog_transfered = this.filter_transfered;
      this.dialog_adultcattle = this.filter_adultcattle;
      this.dialog_calf = this.filter_calf;
      this.dialog_shipping = this.filter_shipping;
      this.dialog_deathdisuse = this.filter_deathdisuse;
      this.dialog_status_noset = this.filter_status_noset;
      this.dialog_cow = this.filter_cow;
      this.dialog_bull = this.filter_bull;
      this.dialog_sex_noset = this.filter_sex_noset;
      this.dialog_wagyu = this.filter_wagyu;
      this.dialog_holstein = this.filter_holstein;
      this.dialog_f1 = this.filter_f1;
      this.dialog_redcow = this.filter_redcow;
      this.dialog_breed_noset = this.filter_breed_noset;
      this.dialog_in_barn = this.filter_in_barn;
      // ダイアログ・オープン
      this.cowSelectFilterDialog = true;
    },
    setFilter() {
      // フィルター設定内容の反映
      this.filter_emptywomb = this.dialog_emptywomb;
      this.filter_inseminated = this.dialog_inseminated;
      this.filter_pregnant = this.dialog_pregnant;
      this.filter_transfered = this.dialog_transfered;
      this.filter_adultcattle = this.dialog_adultcattle;
      this.filter_calf = this.dialog_calf;
      this.filter_shipping = this.dialog_shipping;
      this.filter_deathdisuse = this.dialog_deathdisuse;
      this.filter_status_noset = this.dialog_status_noset;
      this.filter_cow = this.dialog_cow;
      this.filter_bull = this.dialog_bull;
      this.filter_sex_noset = this.dialog_sex_noset;
      this.filter_wagyu = this.dialog_wagyu;
      this.filter_holstein = this.dialog_holstein;
      this.filter_f1 = this.dialog_f1;
      this.filter_redcow = this.dialog_redcow;
      this.filter_breed_noset = this.dialog_breed_noset;
      this.filter_in_barn = this.dialog_in_barn;
      // ダイアログ・クローズ
      this.cowSelectFilterDialog = false;
      // フィルター再適用
      this.filterUpdate();
    },
    filterUpdate() {
      this.saveFilterParam()
      let envFilter = this.filter_emptywomb ||
        this.filter_inseminated ||
        this.filter_pregnant ||
        this.filter_transfered ||
        this.filter_adultcattle ||
        this.filter_calf ||
        this.filter_shipping ||
        this.filter_deathdisuse ||
        this.filter_status_noset ||
        this.filter_cow ||
        this.filter_bull ||
        this.filter_sex_noset ||
        this.filter_wagyu ||
        this.filter_holstein ||
        this.filter_f1 ||
        this.filter_redcow ||
        this.filter_breed_noset ||
        this.filter_in_barn;
      if (envFilter) {
        this.icon_color = colorYellow;
      } else {
        this.icon_color = colorNormal;
      }
      // アイテムソート指定
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (this.sortLevel[idx] > 0) {
          if (this.sortLevel[idx] == 1) {
            // 降順ソート
            this.sortCowsAscending = true
          } else {
            // 昇順ソート
            this.sortCowsAscending = false
          }
          // ソート項目設定
          this.sortOrder = this.cowSortKey[idx]
        }
      }
      this.getCowsDataFirst()
    },
    selectCowsDataID(cow_id) {
      let ret = -1;
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        if ("cow_id" in this.cowsData[idx] && this.cowsData[idx]["cow_id"] === cow_id) {
          ret = idx;
          break;
        }
      }
      return ret;
    },
    selectCancel() {
      // キャンセル
      this.$emit("dialogClose", "calfDialog");
      return;
    }
  },
  watch: {
    cowNumberNames: function () {
      this.setSuggestionsDatas(this.cowNumberNames)
    },
    isSearchNumber: function () {
      this.search_text = ""
      if (this.isSearchNumber) {
        // 耳標・拡張４桁
        this.search_text_placeholder = ConstParam.search_text_placeholder_number
        this.search_text_maxlength = ConstParam.number_maxLength
        this.setSuggestionsData()
      } else {
        // 名前
        this.search_text_placeholder = ConstParam.search_text_placeholder_name
        this.search_text_maxlength = ConstParam.maxLength
        this.setSuggestionsData()
      }
      this.filterUpdate()
    },
    sortCowsData: function () {
      // get_sort_cows対応
      this.sortCowsListData.push(this.sortCowsData.data)
      this.sortCowsListCount.push(this.sortCowsData.data.length)
      this.sortCowsIndexCount++
      this.sortCowsTotalCount = this.getSortCowsCount()
      this.cowsData = structuredClone(this.sortCowsData.data)
      if ("last_key" in this.sortCowsData) {
        this.sortCowsListKey = structuredClone(this.sortCowsData.last_key)
        this.sortCowsListKeyArray.push(this.sortCowsData.last_key)
        this.sortCowsTotalCount++
      } else {
        this.sortCowsListKeyArray.push({})
      }
    },
    updateSortCowsData: function () {
      // get_sort_cows対応
      this.sortCowsListData[this.sortCowsIndex] = structuredClone(this.updateSortCowsData.data)
      this.cowsData = structuredClone(this.updateSortCowsData.data)
    },
    cowsData: function () {
      // 牛一覧情報作成
      let tempTable = [];
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        let tempBarn = "";
        let tempBreed = this.cow_kinds.length - 1;
        if ("cow_breed" in this.cowsData[idx]) {
          tempBreed = this.cowsData[idx]['cow_breed'];
        }
        let tempTransferDate = "";
        if ("transfer_on" in this.cowsData[idx]['last_birth']) {
          tempTransferDate = this.cowsData[idx]['last_birth']['transfer_on'];
        }
        this.cowsData[idx]['last_birth']['inseminate_on']
        let tempData = {
          "id": this.cowsData[idx]['cow_id'],
          "no": this.cowsData[idx]['cow_number'],
          "name": this.cowsData[idx]['cow_name'],
          "sex": this.cowsData[idx]['cow_sex'],
          "breed": this.cow_kinds[tempBreed],
          "birthdate": this.cowsData[idx]['last_birth']['birth_reserve_date'],
          "fertilizationdate": this.cowsData[idx]['last_birth']['inseminate_on'],
          "transferdate": tempTransferDate,
          "lastestruson": this.cowsData[idx]['last_birth']['estrus_on'],
          "lastbirthon": this.cowsData[idx]['last_birth']['birth_on'],
          "barn": tempBarn,
          "status": this.cowsData[idx]['cow_status'],
          "pregnancystatus": this.cowsData[idx]['cow_pregnancy_status']
        }
        tempTable.push(tempData);
      }
      this.tableData = tempTable;
      this.orgTableData = this.tableData;
      if (!this.cow_history && !this.return_history) {
        this.loading = false;
      }
      this.return_history = false;
      if (this.cow_select !== "") {
        this.cowInfoDataSet(this.cow_select);
      }
    },
  }
}
</script>

<style scoped>
.cow-input {
  padding-left: 1em;
}

.el-row {
  justify-content: left;
}

.filter-left {
  margin-left: 74px;
  font-size: 14px;
}

.bottom-padding {
  padding-bottom: 22px;
}

.left-button {
  width: 176px;
  height: 50px;
  color: #383838;
  background: #FFFFFF;
}

.right-button {
  width: 176px;
  height: 50px;
  margin-left: 44px !important;
  color: #383838;
  background: #ffdf5e;
}
</style>
